import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import AOS from "aos";
import "aos/dist/aos.css";
import { Swiper, SwiperSlide } from "swiper/react";
import { Navigation } from "swiper/modules";
import "swiper/css";
import "swiper/css/navigation";
import { Autoplay, Pagination } from "swiper/modules";
import Carousel from "react-bootstrap/Carousel";
import "../../component/Home/Home.css";
// import Footer from "../../../ReactKaamvalaWebsite/component/Footer/Footer";
import { slides, testimonials, jobCards, images } from "./fake_data";
import {
  MdOutlineKeyboardArrowLeft,
  MdOutlineKeyboardArrowRight,
} from "react-icons/md";
import { Link } from "react-router-dom";
import SearchContainer from "./SearchContainer";
const jobCategories = [
  [
    "Accountant",
    "Beautician",
    "Content Writing",
    "Counter sales Job",
    "Digital Marketing",
    "Finance",
    "Hardware Engineer",
    "Housekeeping",
    "Maid",
    "Nursing",
    "Receptionist",
    "Security Guard",
    "Technician",
    "Other",
  ],
  [
    "Articleship",
    "Business Development",
    "Cook",
    "Data Entry",
    "Driver",
    "Graphic Designer",
    "Hotel Management",
    "HR Executive",
    "Marketing",
    "office Boy",
    "Software Developer",
    "Telecalling/BPO",
  ],
  [
    "Computer Operator",
    "Counsellor",
    "Delivery",
    "Engineer(Mechanical/Civil etc.)",
    "Government",
    "Hotel/Waiter",
    "Lab Technician",
    "Medical (Doctor , Dentist etc. )",
    "Back Office",
    "Pean",
    "Sales Executive",
    "Teacher",
    "Trainer",
  ],
];

const Home = () => {
  const {
    slider1,
    slider2,
    slider3,
    slider4,
    zomato,
    zepto,
    blinkit,
    uber,
    udaan,
    hdfc,
    swiggy,
    rapido,
    ola,
    tatamotar,
    urbancompany,
    platform,
    kaamvala,
    kaamvala2,
    kaamvala3,
    kaamvala4,
    realjob,
    realTalent,
    mangeture,
    facebook,
    linkedIn,
    twitter,
    youtube,
    instagram,
    joblogo,
    prev,
    next,
  } = images;
  const navigate = useNavigate();
  const scrollToTop = () => {
    window.scrollTo({
      top: 0,
      behavior: "smooth",
    });
  };

  const handleNavItemClick = (path) => {
    return (e) => {
      e.preventDefault();
      scrollToTop();
      setTimeout(() => navigate(path), 100);
    };
  };
  useEffect(() => {
    AOS.init();
  }, []);
  return (
    <>
      <SearchContainer></SearchContainer>
      <section className="hero-section">
        <div className="container-fluid">
          <div className="row">
            <div className="col-12">
              <div className="hero-container">
                <div className="d-block d-lg-none slider-mobile">
                  <Carousel
                    controls={false}
                    indicators={false}
                    data-bs-theme="dark"
                  >
                    <Carousel.Item interval={1000}>
                      <img
                        width="355"
                        height="315"
                        className="d-block image-fluid adjust-image"
                        src={slider1}
                        alt="First slide"
                      />
                    </Carousel.Item>
                    <Carousel.Item interval={500}>
                      <img
                        width="355"
                        height="315"
                        className="d-block image-fluid adjust-image"
                        src={slider2}
                        alt="Second slide"
                      />
                    </Carousel.Item>
                    <Carousel.Item interval={500}>
                      <img
                        width="355"
                        height="315"
                        className="d-block image-fluid adjust-image"
                        src={slider3}
                        alt="Third slide"
                      />
                    </Carousel.Item>
                    <Carousel.Item interval={500}>
                      <img
                        width="355"
                        height="315"
                        className="d-block image-fluid adjust-image"
                        src={slider4}
                        alt="Fourth slide"
                      />
                    </Carousel.Item>
                  </Carousel>
                </div>
                <div className="hero-content-wrapper">
                  <div className="hero-text">
                    <h1 className="hero-heading">
                      Get Dream Job or Hire the Best Talent with
                      <br />
                      <span className="kaamvala_highlight" id="mera-kaamvala">
                        KAAMVALA!
                      </span>
                    </h1>
                    <p className="hero-subheading">
                      Connecting job seekers with the best companies and
                      opportunities worldwide.
                    </p>
                    <div className="hero-buttons">
                      <button className="btn btn-primary hire-btn">
                        <Link to="/company/login">Hire Now</Link>
                      </button>
                      <button className="btn btn-primary job-btn">
                        <Link to="/user/find-job">Get a Job</Link>
                      </button>
                    </div>
                  </div>

                  <div className="d-none d-lg-block hero-slider">
                    <Carousel
                      controls={false}
                      indicators={false}
                      data-bs-theme="dark"
                    >
                      <Carousel.Item interval={1000}>
                        <img
                          width="355"
                          height="315"
                          className="d-block image-fluid"
                          src={slider1}
                          alt="First slide"
                        />
                      </Carousel.Item>
                      <Carousel.Item interval={500}>
                        <img
                          width="355"
                          height="315"
                          className="d-block image-fluid"
                          src={slider2}
                          alt="Second slide"
                        />
                      </Carousel.Item>
                      <Carousel.Item interval={500}>
                        <img
                          width="355"
                          height="315"
                          className="d-block image-fluid"
                          src={slider3}
                          alt="Third slide"
                        />
                      </Carousel.Item>
                      <Carousel.Item interval={500}>
                        <img
                          width="355"
                          height="315"
                          className="d-block  image-fluid"
                          src={slider4}
                          alt="Fourth slide"
                        />
                      </Carousel.Item>
                    </Carousel>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
      <section className="logo-slider-section">
        <div className="container">
          <div className="logo-slider-heading">
            <h1>Our Top Hiring Partners</h1>
          </div>
          <div className="logo-logo-slider my-4">
            <div className="logo-slide-track">
              <div className="logo-slide">
                <img
                  width="250"
                  height="100"
                  src={zomato}
                  alt="brand-logo"
                  data-opt-lazy-loaded="false"
                />
              </div>
              <div className="logo-slide">
                <img
                  width="250"
                  height="100"
                  src={zepto}
                  alt="brand-logo"
                  data-opt-lazy-loaded="false"
                />
              </div>
              <div className="logo-slide">
                <img
                  width="250"
                  height="100"
                  src={urbancompany}
                  alt="brand-logo"
                  data-opt-lazy-loaded="false"
                />
              </div>
              <div className="logo-slide">
                <img
                  width="250"
                  height="100"
                  src={ola}
                  alt="brand-logo"
                  data-opt-lazy-loaded="false"
                />
              </div>
              <div className="logo-slide">
                <img
                  width="250"
                  height="100"
                  src={rapido}
                  alt="brand-logo"
                  data-opt-lazy-loaded="false"
                />
              </div>
              <div className="logo-slide">
                <img
                  width="250"
                  height="100"
                  src={uber}
                  alt="brand-logo"
                  data-opt-lazy-loaded="false"
                />
              </div>
              <div className="logo-slide">
                <img
                  width="250"
                  height="100"
                  src={tatamotar}
                  alt="brand-logo"
                  data-opt-lazy-loaded="false"
                />
              </div>
              <div className="logo-slide">
                <img
                  width="250"
                  height="100"
                  src={swiggy}
                  alt="brand-logo"
                  data-opt-lazy-loaded="false"
                />
              </div>
              <div className="logo-slide">
                <img
                  width="250"
                  height="100"
                  src={hdfc}
                  alt="brand-logo"
                  data-opt-lazy-loaded="false"
                />
              </div>
              <div className="logo-slide">
                <img
                  width="250"
                  height="100"
                  src={udaan}
                  alt="brand-logo"
                  data-opt-lazy-loaded="false"
                />
              </div>
              <div className="logo-slide">
                <img
                  width="250"
                  height="100"
                  src={blinkit}
                  alt="brand-logo"
                  data-opt-lazy-loaded="false"
                />
              </div>
            </div>
          </div>
        </div>
      </section>
      <section className="platform-section my-4 py-4">
        <div className="container py-4">
          <div className="col-12">
            <div className="platform-text-section">
              <p className="platform-text1">KEY BENEFITS</p>
              <h2 className="h2">
                All You Need, <br />
                <span className="inner-text">In One Platform!</span>
              </h2>
            </div>
          </div>
        </div>
        <div className="container py-5">
          <div className="col-md-12">
            <div className="row d-flex justify-content-center align-items-center">
              <div className="col-lg-6 col-md-12">
                <div className="platform-section-image">
                  <img
                    src={platform}
                    alt="web and app development"
                    height="516"
                    width="482"
                    data-opt-lazy-loaded="false"
                  />
                </div>
              </div>
              <div className="col-lg-6 col-md-12">
                <div className="platform-text">
                  <div className="platform-section-text-commons">
                    <h3 className="heading-h3">
                      Powerful Job Search for Candidates
                    </h3>
                    <p className="text-para-p">
                      Search through thousands of job listings with advanced
                      filters to find opportunities that match your skills and
                      preferences. Set alerts for new jobs tailored to your
                      profile
                    </p>
                  </div>
                  <div className="platform-section-text-commons">
                    <h3 className="heading-h3">
                      Easy Job Posting for Employers
                    </h3>
                    <p className="text-para-p">
                      Post job listings in minutes using our intuitive job
                      creation form. Reach top candidates with customized job
                      posts and attract talent that fits your business needs.
                    </p>
                  </div>
                  <div className="platform-section-text-commons">
                    <h3 className="heading-h3">
                      Seamless Application Management
                    </h3>
                    <p className="text-para-p">
                      Manage applications efficiently with our built-in
                      dashboard. Review candidates, schedule interviews, and
                      communicate easily with potential hires—all in one place.
                    </p>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
      <section className="choose-section-kaamvala">
        <div className="container">
          <div className="col-12">
            <div className="row">
              <div className="choose-heading-kaamvala py-5">
                <h2>Why Choose Kaamvala?</h2>
                <p>
                  We are more than just a job board. Our platform offers smart
                  solutions to connect job seekers with the right opportunities
                  and help employers find top talent quickly and efficiently.
                </p>
              </div>
            </div>
          </div>
          <div className="col-12">
            <div className="row">
              <div className="col-lg-3 col-md-6">
                <div className="kaamvala-img">
                  <img
                    src={kaamvala}
                    alt="Web and app development"
                    width="100"
                    height="100"
                  />
                </div>
                <div className="kaamvala-content mt-4">
                  <h3>Smart Job Matching For Candidates</h3>
                  <p>
                    Our advanced algorithms ensure you see only the most
                    relevant job opportunities based on your skills.
                  </p>
                </div>
              </div>
              <div className="col-lg-3 col-md-6">
                <div className="kaamvala-img">
                  <img
                    src={kaamvala2}
                    alt="Web and app development"
                    width="100"
                    height="100"
                  />
                </div>
                <div className="kaamvala-content mt-4">
                  <h3>Fast and Efficient Hiring for Employers</h3>
                  <p>
                    We help employers streamline the hiring process, making it
                    faster and easier to post jobs, review.
                  </p>
                </div>
              </div>
              <div className="col-lg-3 col-md-6">
                <div className="kaamvala-img">
                  <img
                    src={kaamvala3}
                    alt="Web and app development"
                    width="100"
                    height="100"
                  />
                </div>
                <div className="kaamvala-content mt-4">
                  <h3>Trusted by Thousands of Employers and Candidates</h3>
                  <p>
                    Our platform has helped thousands of professionals find
                    their dream jobs and employers discover the right.
                  </p>
                </div>
              </div>
              <div className="col-lg-3 col-md-6">
                <div className="kaamvala-img">
                  <img
                    src={kaamvala4}
                    alt="Web and app development"
                    width="100"
                    height="100"
                  />
                </div>
                <div className="kaamvala-content mt-4">
                  <h3>Our User’s Security and Privacy First</h3>
                  <p>
                    We value your trust. Our platform is built with robust
                    security measures to protect your personal data.
                  </p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

      <section className="talent-section">
        <div className="container">
          <div className="row">
            <div className="col-12">
              <div className="talent-heading">
                <h2>Explore Talent & Opportunities</h2>
                <p>
                  Whether you're looking for your dream job or seeking the
                  perfect candidate, we've got you covered.
                </p>
              </div>
            </div>
          </div>
          <div className="row">
            <div className="col-12">
              <div className="talent-box">
                <div className="col-lg-6 col-md-6 col-12 real-talent-boxes">
                  <div className="real-talent-box">
                    <h3>Hire the Best & Real Talent</h3>
                    <p>
                      Access a diverse pool of qualified candidates. Our
                      platform simplifies the hiring process, helping you find
                      the right fit quickly and efficiently.
                    </p>
                    <div className="real-talent-box-image">
                      <img
                        src={realTalent}
                        className="img-fluid"
                        alt="Hiring talent illustration"
                      />
                    </div>
                  </div>
                  <div
                    className="real-talent-box-btn"
                    style={{
                      paddingLeft: "25px",
                    }}
                  >
                    <button>
                      <Link to="/company/login">Hire Now</Link>
                    </button>
                  </div>
                </div>
                <div className="col-lg-6 col-md-6 col-12 real-talent-boxes">
                  <div className="real-talent-box">
                    <h3>1000+ Daily Real Jobs</h3>
                    <p>
                      Latest job listings across various industries. With
                      personalized recommendations, you can quickly find
                      positions that match your skills and career.
                    </p>
                    <div className="real-talent-box-image">
                      <img
                        src={realjob}
                        className="img-fluid"
                        alt="Job opportunities illustration"
                      />
                    </div>
                  </div>
                  <div
                    className="real-talent-box-btn"
                    style={{
                      paddingLeft: "25px",
                    }}
                  >
                    <button>
                      <Link to="/user/find-job">Get a Job</Link>
                    </button>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
      <section id="Feature-Jobs">
        <div className="container feature-sections">
          <div className="col-12">
            <div className="row">
              <div className="choose-kaamvala-heading py-5">
                <h2>Hear What Our Users Are Saying</h2>
                <p>
                  Our platform is helping thousands of job seekers and employers
                  find success. See how Kaamvala is making a difference for
                  people just like you.
                </p>
              </div>
            </div>
            <div className="row">
              <div className="col-lg-12 col-md-12 swiper-container-testimonials-column">
                <div
                  className="swiper-container-testimonials slide-content slide-testimonials"
                  data-aos="fade-up"
                >
                  <Swiper
                    modules={[Navigation]}
                    spaceBetween={30}
                    slidesPerView={1}
                    centeredSlides={true}
                    loop={true}
                    navigation={{
                      nextEl: ".swiper-button-next-testimonials",
                      prevEl: ".swiper-button-prev-testimonials",
                    }}
                    breakpoints={{
                      0: {
                        slidesPerView: 1,
                        centeredSlides: true,
                      },
                      426: {
                        slidesPerView: 1,
                        centeredSlides: true,
                        spaceBetween: 20,
                      },
                      768: {
                        slidesPerView: 2,
                        centeredSlides: true,
                      },
                      991: {
                        slidesPerView: 3.5,
                      },
                    }}
                    className="swiper-testimonial-wrapper"
                  >
                    {testimonials.map((testimonial) => (
                      <SwiperSlide
                        key={testimonial.id}
                        className="swiper-slider"
                      >
                        <div className="testimonial-slide">
                          <p>{testimonial.text}</p>
                          <div className="testimonial-slider-owner">
                            <div className="testimonial-slider-img">
                              <img
                                src={joblogo}
                                height="64"
                                width="64"
                                alt="Web and app development"
                                title="Web and app development"
                              />
                            </div>
                            <div className="testimonia-slider-owner-name">
                              <h6>{testimonial.name}</h6>
                              <p>{testimonial.role}</p>
                            </div>
                          </div>
                        </div>
                      </SwiperSlide>
                    ))}
                  </Swiper>
                  <div className="swiper-navigation-testimonials">
                    <div className="swiper-button-prev swiper-button-prev-testimonials">
                      <img
                        src={prev}
                        height="12"
                        width="12"
                        alt="next-icon"
                        title="Web and app development"
                        style={{ marginRight: "10px" }}
                      />
                      Prev
                    </div>
                    <div className="swiper-button-next swiper-button-next-testimonials">
                      Next
                      <img
                        src={next}
                        height="12"
                        width="12"
                        alt="next-icon"
                        title="Web and app development"
                        style={{ marginLeft: "10px" }}
                      />
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

      <section id="Feature-section-2">
        <div className="container feature-section">
          <div className="row">
            <div
              className="col-lg-6 col-md-6
            "
            >
              <div className="feature-section-heading">
                <h2>Our Featured Jobs!</h2>
                <p>
                  Explore top job opportunities from leading companies. Find
                  positions that match your skills and take the next step in
                  your career!
                </p>
                <button>
                  <a href="">Explore Now</a>
                </button>
              </div>
            </div>
            <div className="col-lg-6 col-md-12 swiper-container-column">
              <Swiper
                // modules={[Navigation]}
                modules={[Autoplay, Pagination, Navigation]}
                spaceBetween={30}
                slidesPerView={1}
                centeredSlides={true}
                loop={true}
                navigation={{
                  nextEl: ".swiper-button-next-job-card",
                  prevEl: ".swiper-button-prev-job-card",
                }}
                autoplay={{
                  delay: 3000,
                  disableOnInteraction: false,
                }}
                pagination={{
                  clickable: true,
                }}
                breakpoints={{
                  0: {
                    slidesPerView: 1,
                    centeredSlides: true,
                  },
                  768: {
                    slidesPerView: 2,
                    centeredSlides: true,
                  },
                }}
                className="slide-content job-card-content swiper-container"
              >
                {jobCards.map((job) => (
                  <SwiperSlide key={job.id}>
                    <div className="job-card">
                      <div className="card">
                        {/* <div> */}
                        <div className="feature-card-body-content">
                          <div className="feautre-card-body-img">
                            <img
                              src={joblogo}
                              height="52"
                              width="52"
                              alt="Web and app development"
                              title="Web and app development"
                            />
                          </div>
                          <div className="feautre-card-body-text">
                            <h6 className="card-title">{job.title}</h6>
                            <p className="card-subtitle mb-2 text-muted">
                              {job.company}
                            </p>
                          </div>
                          <div className="feautre-card-body-job-post">
                            <p>{job.posted}</p>
                          </div>
                        </div>
                        <div className="feature-card-body-salary my-2">
                          <p>{job.experience}</p>
                          <p>{job.salary}</p>
                          <p>{job.location}</p>
                        </div>
                        <div className="feature-card-body-workmode my-2">
                          <p>{job.workMode}</p>
                          <p>{job.hybrid}</p>
                          <p>{job.shift}</p>
                        </div>
                        <div className="feature-card-body-description">
                          <p>{job.description}</p>
                        </div>
                        {/* </div> */}
                      </div>
                    </div>
                  </SwiperSlide>
                ))}

                <div className="swiper-button-prev swiper-button-prev-job-card">
                  <MdOutlineKeyboardArrowLeft />
                </div>
                <div className="swiper-button-next swiper-button-next-job-card">
                  <MdOutlineKeyboardArrowRight />
                </div>
              </Swiper>
            </div>
          </div>
          <style jsx>{`
            .job-card {
              width: 460px;
              display: flex;
              flex-direction: column;
              justify-content: center;
              box-shadow: 3px 3px 16px 0px rgba(0, 0, 0, 0.08);
              box-shadow: -3px -3px 16px 0px rgba(0, 0, 0, 0.08);
              background: rgba(255, 255, 255, 1);
              border-radius: 8px;
            }
            .swiper-slide {
              display: flex;
              justify-content: center;
              align-items: center;
              gap: 2rem;
            }
            .swiper-container-column {
              display: flex;
              overflow: hidden;
              justify-content: center;
              align-items: center;
            }

            .swiper-container {
              width: 750px !important;
              overflow: unset;
            }
            .card-body {
              border: unset !important;
            }
            .card {
              padding: 10px 20px;
            }
            .job-card-content .swiper-button-next-job-card {
              width: 48px;
              height: 48px;
              background: rgba(50, 132, 255, 1);
              border-radius: 50%;
              color: #fff;
              display: none;
              display: flex;
              align-items: center;
              justify-content: center;
            }

            // .swiper-button-prev.swiper-button-prev-job-card {
            //   margin-left: 90px;
            // }
            // .swiper-button-next.swiper-button-next-job-card {
            //   margin-right: 90px;
            // }
            .job-card-content .swiper-button-prev-job-card {
              width: 48px;
              height: 48px;
              background: rgba(50, 132, 255, 1);
              border-radius: 50%;
              color: #fff;
              display: flex;
              display: none;
              align-items: center;
              justify-content: center;
            }
            @media screen and (max-width: 426px) {
              .job-card {
                width: 335px;
                margin-top: 25px;
              }
            }

            .swiper-button-next::after,
            .swiper-button-prev::after {
              display: none;
            }
          `}</style>
        </div>
      </section>
      <section className="Feature-again">
        <div className="container">
          <div className="col-md-12 py-5">
            <Swiper
              modules={[Autoplay, Pagination]}
              spaceBetween={30}
              slidesPerView={1}
              loop={true}
              autoplay={{
                delay: 5000,
                disableOnInteraction: false,
              }}
              pagination={{
                clickable: true,
              }}
            >
              {slides.map((slide, index) => (
                <SwiperSlide key={index}>
                  <div className="row d-flex align-items-center my-auto justify-content-center">
                    <div className="col-lg-6 col-md-12">
                      <div className="feature-section-heading mt-4">
                        <h2>{slide.title}</h2>
                        <p>{slide.description}</p>
                        <button>
                          <a href="">{slide.buttonText}</a>
                        </button>
                      </div>
                    </div>
                    <div className="col-lg-5 col-md-12">
                      <div className="slider-image">
                        <img
                          src={slide.image}
                          alt={slide.alt}
                          className="d-block img-fluid w-100 feature-image-2"
                        />
                      </div>
                    </div>
                  </div>
                </SwiperSlide>
              ))}
            </Swiper>
          </div>
        </div>
      </section>
      <section className="dream-job-section">
        <div className="container">
          <div className="row">
            <div className="col-12">
              <div className="find-your-dream-job-section">
                <div className="col-lg-6 col-md-12 real-talent-boxes">
                  <div className="feature-heading find-your-dream-job-heading">
                    <h2
                      className="dream-text-h1"
                      style={{
                        color: "#fff",
                      }}
                    >
                      Ready to Find Your Dream Job or Hire Top Talent?
                    </h2>
                    <p
                      style={{
                        color: "#fff",
                      }}
                    >
                      Whether you're searching for the perfect role or looking
                      to build your team, Kaamvala is here to help you succeed.
                      Start today and discover a world of opportunities.
                    </p>
                    <div className="dream-job-btn">
                      <button>
                        <Link
                          to="/company/login"
                          style={{
                            color: " rgba(50, 132, 255, 1)",
                            textDecoration: "none",
                          }}
                        >
                          Hire Now
                        </Link>
                      </button>
                      <button>
                        <Link
                          to="/user/find-job"
                          style={{
                            color: " rgba(50, 132, 255, 1)",
                            textDecoration: "none",
                          }}
                        >
                          Get the Job
                        </Link>
                      </button>
                    </div>
                  </div>
                </div>
                <div className="col-lg-6 col-md-12 real-talent-boxes">
                  <div className="dream-image">
                    <img
                      src={mangeture}
                      width="442"
                      height="512"
                      className="d-block img-fluid"
                      alt=""
                    />
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
      <section id="follow">
        <div className="container">
          <div className="col-md-12 text-center footer-title my-4">
            <h3>Follow Us</h3>
          </div>
          <div className="row">
            <div className="col-md-12 d-flex justify-content-around my-5 footer-bherf3ww">
              <div className="footer-icons">
                <Link href>
                  <img
                    src={facebook}
                    className="d-block"
                    width="45"
                    height="45"
                    alt="web and app development"
                    title="web and app development"
                    loading="lazy"
                    data-opt-lazy-loaded="false"
                  />
                </Link>
              </div>
              <div className="footer-icons">
                <Link href>
                  <img
                    src={linkedIn}
                    className="d-block "
                    width="45"
                    height="45"
                    alt="web and app development"
                    title="web and app development"
                    loading="lazy"
                    data-opt-lazy-loaded="false"
                  />
                </Link>
              </div>
              <div className="footer-icons">
                <Link href>
                  <img
                    src={youtube}
                    className="d-block "
                    width="45"
                    height="45"
                    alt="web and app development"
                    title="web and app development"
                    loading="lazy"
                    data-opt-lazy-loaded="false"
                  />
                </Link>
              </div>
              <div className="footer-icons">
                <Link href>
                  <img
                    src={twitter}
                    className="d-block "
                    width="45"
                    height="45"
                    alt="web and app development"
                    title="web and app development"
                    loading="lazy"
                    data-opt-lazy-loaded="false"
                  />
                </Link>
              </div>
              <div className="footer-icons">
                <a href>
                  <img
                    src={instagram}
                    className="d-block "
                    width="45"
                    height="45"
                    alt="web and app development"
                    title="web and app development"
                    loading="lazy"
                    data-opt-lazy-loaded="false"
                  />
                </a>
              </div>
            </div>
          </div>

          <div className="container">
            <div className="row">
              <div className="col-md-12 col-lg-12 justify-content-center mx-auto">
                <div className="quick-link-content d-flex justify-content-around m-auto">
                  {[
                    { path: "/company/about-us", label: "About" },
                    { path: "/employer/price-detail", label: "Price" },
                    { path: "/company/culture", label: "Culture" },
                    { path: "/company/contact", label: "Contact Us" },
                    { path: "/employer/post-job", label: "Starting Hiring" },
                    { path: "/company/fqa", label: "FAQ" },
                    { path: "/employer/policy", label: "Refund Policy" },
                    { path: "", label: "Candidate" },
                  ].map((item, index) => (
                    <Link
                      key={index}
                      to={item.path}
                      onClick={
                        item.path ? handleNavItemClick(item.path) : undefined
                      }
                    >
                      {item.label}
                    </Link>
                  ))}
                </div>
              </div>
            </div>
          </div>
          <div className="container my-5">
            <div className="row">
              <div className="col-md-12 col-lg-12">
                <div></div>
              </div>
            </div>
          </div>
          <div className="container">
            <div className="container justify-content-center mx-auto">
              <div className="row">
                <div className="footer_quick_link_title my-2 ml-2">
                  <div className="col-md-12 col-lg-12 text-align-left">
                    <h6>Find Jobs By Type</h6>
                  </div>
                </div>
              </div>
              <div className="row">
                {[
                  [
                    "Accountant",
                    "Beautician",
                    "Blacksmith",
                    "Counter sales Job",
                    "Car Wash Attendant",
                    "Concrete Finisher",
                    "Hardware Engineer",
                    "Counter sales Job",
                    "Housenkeeping",
                    "Maid",
                    "Nursing",
                    "Receptionist",
                    "Security Guard",
                    "Electrician",
                    "Other",
                  ],

                  [
                    "Glass Cutter",
                    "Cook",
                    "Data Entry",
                    "Driver",
                    "Mason",
                    "Blacksmith",
                    "Blacksmith",
                    "Blacksmith",
                    "Hotel Management",
                    "painter",
                    "Marketing",
                    "office Boy",
                    "Retail",
                    "pipe Welder",
                    "Telecalling/BPO",
                  ],

                  [
                    "Waste Collector",
                    "Computer Operator",
                    "Welder",
                    "Delivery",
                    "Engineer(Mechanical/Civil etc.)",
                    "Government",
                    "Hotel/Waiter",
                    "Lab Technician",
                    "Medical (Doctor , Dentist etc.)",
                    "Pean",
                    "Sales Executive",
                    "Teacher",
                    "Trainer",
                  ],
                ].map((column, colIndex) => (
                  <div className="col-md-4 col-lg-4" key={`col-${colIndex}`}>
                    <div className="footer_quick_links my-2">
                      {column.map((job, jobIndex) =>
                        colIndex === 0 || colIndex === 1 ? (
                          <Link to="#" key={`job-${colIndex}-${jobIndex}`}>
                            {job}
                          </Link>
                        ) : (
                          <Link to="#" key={`job-${colIndex}-${jobIndex}`}>
                            {job}
                          </Link>
                        )
                      )}
                    </div>
                  </div>
                ))}
              </div>
            </div>

            <div className="container justify-content-center mx-auto">
              <div className="row">
                <div className="footer_quick_link_title my-2 ml-2">
                  <div className="col-md-12 col-lg-12 text-align-left">
                    <h6>Find Work From Home Jobs By Type</h6>
                  </div>
                </div>
              </div>
              <div className="row">
                {jobCategories.map((column, index) => (
                  <div className="col-md-4 col-lg-4" key={index}>
                    <div className="footer_quick_links my-2">
                      {column.map((job, jobIndex) => (
                        <Link href="#" key={jobIndex}>
                          {job}
                        </Link>
                      ))}
                    </div>
                  </div>
                ))}
              </div>
            </div>

            <div className="container">
              <div className="row">
                {[
                  {
                    title: "Find Jobs By City",
                    links: [
                      "Mumbai",
                      "Pune",
                      "Banglore",
                      "Delhi/NCR",
                      "Ahmedabad",
                      "Surat",
                      "Nagpur",
                      "Nashik",
                    ],
                  },
                  {
                    title: "Find Jobs By Education",
                    links: [
                      "Graduate",
                      "12th Pass",
                      "10th Pass",
                      "Below 10th Pass",
                    ],
                  },
                  {
                    title: "Find Jobs By Experience Level",
                    links: ["Fresher", "Experience"],
                  },
                ].map((section, index) => (
                  <div className="col-md-4 col-lg-4" key={`section-${index}`}>
                    <div className="row">
                      <div className="footer_quick_link_title my-2 ml-2">
                        <div className="col-md-12 col-lg-12 text-align-left py-2">
                          <h6>{section.title}</h6>
                        </div>
                      </div>
                    </div>
                    <div className="footer_quick_links">
                      {section.links.map((link, linkIndex) => (
                        <Link
                          to="#"
                          className="link-quick d-block mb-1"
                          key={`link-${index}-${linkIndex}`}
                        >
                          {link}
                        </Link>
                      ))}
                    </div>
                  </div>
                ))}
              </div>
            </div>

            <div className="container">
              <div className="row">
                {/* Cities Section */}
                <div className="col-md-4 col-lg-4">
                  <div className="row">
                    <div className="footer_quick_link_title my-2 ml-2">
                      <div className="col-md-12 col-lg-12 text-align-left py-2">
                        <h6>Find Work From Home Jobs By City</h6>
                      </div>
                    </div>
                  </div>
                  <div className="footer_quick_links">
                    {[
                      "Mumbai",
                      "Pune",
                      "Banglore",
                      "Delhi/NCR",
                      "Ahmedabad",
                      "Surat",
                      "Nagpur",
                      "Nashik",
                    ].map((city) => (
                      <Link to="#" className="link-quick" key={city}>
                        {city}
                      </Link>
                    ))}
                  </div>
                </div>

                {/* Qualifications Section */}
                <div className="col-md-4 col-lg-4">
                  <div className="row">
                    <div className="footer_quick_link_title my-2 ml-2">
                      <div className="col-md-12 col-lg-12 text-align-left py-2">
                        <h6>Find Work From Home Jobs By Qualification</h6>
                      </div>
                    </div>
                  </div>
                  <div className="footer_quick_links">
                    {[
                      "Graduate",
                      "12th Pass",
                      "10th Pass",
                      "Below 10th Pass",
                    ].map((qualification) => (
                      <Link to="#" className="link-quick" key={qualification}>
                        {qualification}
                      </Link>
                    ))}
                  </div>
                </div>

                {/* Experience Section */}
                <div className="col-md-4 col-lg-4">
                  <div className="row">
                    <div className="footer_quick_link_title my-2 ml-2">
                      <div className="col-md-12 col-lg-12 text-align-left py-2">
                        <h6>Find Work From Home Jobs By Experience Level</h6>
                      </div>
                    </div>
                  </div>
                  <div className="footer_quick_links">
                    {["Fresher", "Experience"].map((experience) => (
                      <Link to="#" className="link-quick" key={experience}>
                        {experience}
                      </Link>
                    ))}
                  </div>
                </div>
              </div>
            </div>
            <div className="container my-2">
              <div className="row">
                <div className="col-md-4 col-lg-4">
                  <div className="row">
                    <div className="footer_quick_link_title my-2 ml-2">
                      <div className="col-md-12 col-lg-12 text-align-left py-2">
                        <h6>Post Jobs In City</h6>
                      </div>
                    </div>
                  </div>
                  <div className="footer_quick_links">
                    <a href="" className="link-quick">
                      Mumbai
                    </a>
                    <a href="" className="link-quick">
                      Delhi
                    </a>
                    <a href="" className="link-quick">
                      Pune
                    </a>
                    <a href="" className="link-quick">
                      Banglore
                    </a>
                    <a href="" className="link-quick">
                      Ahmedabad
                    </a>
                    <a href="" className="link-quick">
                      Chennai
                    </a>
                  </div>
                </div>
                <div className="col-md-4 col-lg-4">
                  <div className="footer_quick_links pt-5">
                    <Link to="" className="link-quick pt-3">
                      Hyderabad
                    </Link>
                    <Link className="link-quick pt-3">Jaipur</Link>
                    <Link className="link-quick pt-3">Chandigarh</Link>
                    <Link className="link-quick pt-3">Lucknow</Link>
                    <Link className="link-quick pt-3">Nagpur</Link>
                    <Link className="link-quick pt-3">Indore</Link>
                    <Link className="link-quick pt-3">Surat</Link>
                  </div>
                </div>
                <div className="col-md-4 col-lg-4">
                  <div className="row">
                    <div className="footer_quick_link_title my-2 ml-2">
                      <div className="col-md-12 col-lg-12 text-align-left py-2">
                        <h6>Find Jobs in Sector</h6>
                      </div>
                    </div>
                  </div>
                  <div className="footer_quick_links">
                    <Link to="#" className="link-quick">
                      Telecalling
                    </Link>
                    <Link href="#" className="link-quick">
                      Cook
                    </Link>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
      {/* <Footer></Footer> */}
    </>
  );
};
export default Home;
